



















































































































































import { Vue, Component } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import { TrackRecords } from "@/api";
import Loading from "@/components/loader/loading.vue";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import { getDayEndLocal, getDayStartLocal } from "@/tool/beginAtEndAt";

type GuardianList = {
  id: number;
  name: string;
};

@Component({
  components: {
    Loading,
    ConfirmationModule,
  },
})
export default class Tracking extends Vue {
  loading = false;
  datePicker = false;
  range: string[] = [];
  headings: string[] = [];
  headingDates: string[] = [];
  guardianId = 0;
  guardianList: Array<GuardianList> = [];
  radioValue = 1;
  viewMode: "daily" | "weekly" = "weekly";
  previousViewMode: "daily" | "weekly" = "weekly";
  pendingViewMode: "daily" | "weekly" = "weekly";
  confirmDialog = false;
  updating = false;
  minDate = moment()
    .local()
    .format("YYYY-MM-DD");

  async created() {
    this.loading = true;
    const company = this.$store.state.appContext.company;
    this.viewMode =
      (company?.inspectionPeriod as "daily" | "weekly") || "weekly";
    this.previousViewMode = this.viewMode;
    this.pendingViewMode = this.viewMode;
    this.defaultDates();
    this.setHeadings();
    await this.fetchTrackingRecords();
    this.loading = false;
  }

  get formattedDates() {
    const [date1, date2] = this.range;
    let beginDate = "";
    let endDate = "";
    if (date1 < date2) {
      beginDate = date1;
      endDate = date2;
    } else {
      beginDate = date2;
      endDate = date1;
    }
    const formattedDate = this.range
      ? `${moment(beginDate).format("MMM DD")}  -  ${moment(endDate).format(
          "MMM DD",
        )}`
      : "";
    return formattedDate;
  }

  defaultDates() {
    this.guardianId = 0;
    if (this.viewMode === "daily") {
      this.range = [
        moment()
          .startOf("week")
          .format("YYYY-MM-DD"),
        moment()
          .endOf("week")
          .format("YYYY-MM-DD"),
      ];
    } else {
      this.range = [
        moment()
          .subtract(5, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD"),
        moment()
          .endOf("week")
          .format("YYYY-MM-DD"),
      ];
    }
  }

  handleViewModeChange() {
    this.pendingViewMode = this.viewMode;
    this.viewMode = this.previousViewMode;
    this.confirmDialog = true;
  }

  async confirmViewModeChange() {
    this.updating = true;
    await this.$store.dispatch("udpateCompanyInspectionPeriod", {
      insectionPeriod: this.pendingViewMode,
    });
    this.viewMode = this.pendingViewMode;
    this.previousViewMode = this.pendingViewMode;
    this.confirmDialog = false;
    this.updating = false;
    this.defaultDates();
    await this.fetchTrackingRecords();
  }

  revertViewMode() {
    this.viewMode = this.previousViewMode;
  }

  setHeadings() {
    const beginAt = this.range[0];
    const endAt = this.range[1];
    this.headings = [];
    this.headingDates = [];

    if (this.viewMode === "daily") {
      const current = moment(beginAt);
      const end = moment(endAt);
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        this.headingDates.push(dateStr);
        this.headings.push(current.format("MMM DD"));
        current.add(1, "day");
      }
    } else {
      const endOfWeek = moment(endAt).endOf("week");
      let i = 0;
      /* eslint-disable no-constant-condition */
      while (true) {
        const weekStart = moment(beginAt)
          .add(7 * i, "days")
          .startOf("week");
        const weekEnd = weekStart.clone().endOf("week");
        const check = weekEnd.isBefore(endOfWeek) || weekEnd.isSame(endOfWeek);
        if (check) {
          this.headingDates.push(weekStart.format("YYYY-MM-DD"));
          this.headings.push(
            `${weekStart.format("MMM DD")} - ${weekEnd.format("MMM DD")}`,
          );
          i++;
        } else {
          break;
        }
      }
    }
  }

  get GuardianAngels() {
    let lists =
      (this.$store.getters["inspection/tracking"] as TrackRecords) || [];
    this.guardianList = [];
    _.forEach(lists, item => {
      if (item)
        this.guardianList.push({
          id: item.id,
          name: item.name,
        });
    });

    if (this.guardianId) {
      lists = _.filter(lists, item => item.id == this.guardianId);
    }
    return _.map(lists, item => {
      const ga = JSON.parse(JSON.stringify(item));
      const sorted = _.sortBy(item.record, rec => rec.from);
      const recordMap = new Map<string, boolean>();
      _.forEach(sorted, rec => {
        const dateKey = rec.from ? rec.from.substring(0, 10) : "";
        if (dateKey) recordMap.set(dateKey, rec.completed);
      });
      ga.record = _.map(this.headingDates, dateStr => ({
        from: dateStr,
        to: dateStr,
        completed: recordMap.get(dateStr) || false,
      }));
      return ga;
    });
  }

  async fetchTrackingRecords(rateStart = false) {
    this.setHeadings();
    let beginAt = this.range[0];
    let endAt = this.range[1];
    if (beginAt && endAt) {
      beginAt = getDayStartLocal(beginAt);
      endAt = getDayEndLocal(endAt);
    }
    await this.$store.dispatch("inspection/fetchTracking", {
      beginAt,
      endAt,
      rateStart,
    });
  }
}
